import { useEffect } from "react";
import { type TradeInAemDispatchType, useTradeInAemSelector } from "../redux/store";
import Debug from "../../common-deprecated/Debug";
import { setTradeInSetShowInModal } from "../redux/actions/TradeInAemUtilsActions";
import { useDispatch } from "../../shared-logic/redux/store";

type HookReturnType = { showInline: boolean; showModal: boolean; closeModal: () => void };

/**
 * Handles the multiple injection modes of tradein. Either inline or inside a modal after a button is clicked.
 */
const useTradeInModalToggle = (): HookReturnType => {
    const dispatch = useDispatch<TradeInAemDispatchType>();
    const tradeInModalToggleId = useTradeInAemSelector((state) => state.commonSettings.query.tradeInModalToggleId);
    // Indicates the active state of the modal wrapper, only relevant when showInModal above is active.
    const showStandaloneModal = useTradeInAemSelector((state) => state.tradeInAemUtils.showStandaloneModal);

    useEffect(() => {
        if (!tradeInModalToggleId) return;

        const element = document.querySelector(`#${tradeInModalToggleId}`);
        if (!element) {
            Debug.warn(`TradeIn injected with modalToggleId ${tradeInModalToggleId}, but no such element was found`);
            return;
        }

        const handleClick = (event: Event): void => {
            event.preventDefault();
            dispatch(setTradeInSetShowInModal(true));
        };
        element.addEventListener("click", handleClick);
        return (): void => element.removeEventListener("click", handleClick);
    }, []);

    return {
        showInline: !tradeInModalToggleId,
        showModal: showStandaloneModal,
        closeModal: (): void => {
            dispatch(setTradeInSetShowInModal(false));
        },
    };
};

export default useTradeInModalToggle;
